var render = function render(){var _vm=this,_c=_vm._self._c;return _c('li',{staticClass:"list-item"},[(_vm.page.data)?_c('nuxt-link',{staticClass:"list-item__link",attrs:{"to":_vm.$prismic.linkResolver(_vm.page)}},[_c('PrismicImage',{staticClass:"link-img",attrs:{"img":_vm.page.data.image}}),_vm._v(" "),_c('div',{staticClass:"link-text"},[_vm._v(_vm._s(_vm.page.data.title))])],1):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }